import React from "react";

const DEFAULT_COUNT = 12;

type CrosshairCatalogSkeletonProps = {
    count?: number;
    className?: string;
};

/** Reserves catalog card-sized space while the first page is loading to reduce CLS. */
export function CrosshairCatalogSkeleton({ count = DEFAULT_COUNT, className }: CrosshairCatalogSkeletonProps) {
    return (
        <>
            {Array.from({ length: count }, (_, i) => (
                <div
                    key={i}
                    className={
                        "crosshair-canvas-preview crosshair-canvas-preview--titled crosshair-canvas-preview--skeleton" +
                        (className ? ` ${className}` : "")
                    }
                    aria-hidden="true"
                />
            ))}
        </>
    );
}
